import {Button} from "@reside/ui";

import {useFacilitySettingsParams} from "../../../hooks/useFacilitySettingsParams";
import {useTemplateHasArbitrationDocumentQuery} from "../../../../../models/pcc";
import {
  downloadWorkflowPdf,
  downloadBlankPdf,
  hasArbitrationDocument,
} from "../../../../../services/AdmissionsService";
import {useDownloadManager} from "../../../../../hooks/useDownloadManager";

type DownloadArbitrationPDFButtonProps = {
  facilityTemplate: string;
  type: "empty" | "in-progress";
  admissionId?: string;
  templateDocumentTypes?: ReadonlyArray<string>;
};

export const DownloadArbitrationPDFButton = ({
  facilityTemplate,
  type,
  admissionId,
  templateDocumentTypes,
}: DownloadArbitrationPDFButtonProps): JSX.Element => {
  const {facilityId} = useFacilitySettingsParams();
  const {start} = useDownloadManager();

  const {data: templateData, isLoading: isLoadingTemplate} =
    useTemplateHasArbitrationDocumentQuery(facilityId, facilityTemplate, {
      enabled: type === "empty" && !!facilityId && !!facilityTemplate,
    });

  const shouldShow =
    (type === "empty" &&
      !isLoadingTemplate &&
      templateData?.hasArbitrationDocument === true) ||
    (type === "in-progress" && hasArbitrationDocument(templateDocumentTypes));

  if (!shouldShow) {
    return null;
  }

  return (
    <Button
      color="primary"
      outline
      onClick={() => {
        if (type === "empty") {
          start("Download Empty Arbitration Packet", () =>
            downloadBlankPdf(facilityId, facilityTemplate, {
              type: "arbitration",
            }),
          );
        } else if (type === "in-progress" && admissionId) {
          downloadWorkflowPdf({
            workflowId: admissionId,
            type: "arbitration",
            status: "IN_PROGRESS",
          });
        }
      }}
    >
      Download
    </Button>
  );
};
